<template>
  <v-scroll-x-transition>
    <v-row no-gutters align-content="center">
      <v-col cols="6" class="my-8" align="right">
        <a target="_blank" class="mx-4" href="https://t.me/mkarta_me">
          <v-icon size="50">$custom_telegram</v-icon>
        </a>
      </v-col>
      <v-col cols="6" class="my-8" align="left">
        <a target="_blank" class="mx-4" href="https://vk.com/mkarta_me">
          <v-icon size="50">$custom_vkontakte</v-icon>
        </a>
      </v-col>
    </v-row>
  </v-scroll-x-transition>
</template>

<script>

export default {
  name: 'LeftMenuSocial',
  data () {
    return {
    }
  },
  computed: {},
  methods: {},
  created () {}
}

</script>

<style scoped lang="scss">

</style>
